<button mat-button [disabled]="isDisabled" (click)="btnClick.emit()">
  {{  buttonText | translate }}
</button>

